import { LectureWithScheduleMetadata } from '../../../../../../../api/types/programs/course/lectures/lecture-with-schedule-metadata';
import { userAttendance } from '../componenets/attendance-lesson-not-started-data-form';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import globalCourseStore from '../../../../../../../stores/global-course-store';
import globalLectureBuilderStore from '../../../../../../../stores/global-lecture-builder-store';

export const updateAttendanceOperations = async (
  programId: number | undefined,
  lecture: LectureWithScheduleMetadata | null,
  studentAttendance: userAttendance[],
) => {
  try {
    if (!lecture) {
      toast.warn('לא ניתן לבצע את הפעולה המבוקש, נסה שוב בעוד מספר רגעים');
      return;
    }

    if (isNaN(Number(programId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה הקורס ו/או התוכנית כעת, נסה שוב בעוד מספר רגעים',
      );
      return;
    }

    const res = await appApi.upsetLectureAttendance(
      programId!,
      lecture.item.courseId,
      lecture.item.id,
      studentAttendance,
    );

    // Update the course lectures state
    const currentCourse = globalCourseStore.getCurrentCourse();
    if (currentCourse?.details) {
      currentCourse.details.lectures = res.data.body;
    }

    // Update the state so the dialog of the lecture will be close
    globalLectureBuilderStore.selectedLecture = null;

    toast.success('הפעולה בוצעה בהצלחה');
  } catch (e) {}
};
